import * as React from 'react';
import { Route, Switch } from 'react-router';

import { IRouteConfigComponent } from '@interfaces';

import { IRouterSwitchParams } from './types';

export const RouterSwitch = (routes: IRouteConfigComponent[]) =>
	(_switchProps: IRouterSwitchParams) =>
		<Switch>
			{routes.map((routeConfig, index) => {
				const { component: Comp, ...route } = routeConfig;

				return <Route
					key={String(route.path || index)}
					{...route}
					render={(props) => Comp
						? React.createElement(Comp, { ...props, route })
						: null}
				/>;
			})}
		</Switch>;
